import createClient from 'openapi-fetch';
import type { paths } from './schema';
import { csrfMiddleware } from '../middleware';

const baseUrl = import.meta.env.VITE_API_BASE_URL ?? '/';

export const apiClient = createClient<paths>({
  baseUrl,
  credentials: 'include',
  fetch: (input) => globalThis.fetch(input),
});

apiClient.use(csrfMiddleware);
